export default "<img  [@fadeBasic]=\"open ? 'show' : 'hide'\"  (@fadeBasic.done)=\"endFade()\" [src]=\"srcImg\" (load)=\"loadImg()\">"